import Vue from 'vue'

import { prepareFile, prepareFailedResponse, createAPI } from 'w3box-vue-api'

export default {
  ...createAPI('/api/users'),
  setSettings: (settings) => new Promise((resolve, reject) => {
    return Vue.http.post('/api/user/settings', settings).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  updateProfile: (data) => new Promise((resolve, reject) => {
    const { params, options } = prepareFile(data)
    return Vue.http.post('/api/user/profile', params, options).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  login: (credentials) => new Promise((resolve, reject) => {
    credentials._token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    return Vue.http.post('/login', credentials).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  logout: () => new Promise((resolve, reject) => {
    return Vue.http.post('/api/user/logout').then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  setOrder: data => new Promise((resolve, reject) => {
    return Vue.http.post('/api/users/sort', data).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
}